export const formatPercentage = (value: number): string => {
  let res = (value * 100);

  if (String(res).includes('.')) 
    return `${Number(res).toFixed(2)}%`
  else 
    return `${String(res)}%`
}